import { Box, Drawer, IconButton } from '@mui/material';
import { styled } from '@mui/material/styles';

interface MenuButtonProps {
  active: number;
}

export const MobileDrawer = styled(Drawer)(() => ({
  '.MuiPaper-root': {
    top: 'calc(59px + var(--kipify-topbar-height, 0px))',
    height: 'calc(100dvh - (60px + var(--kipify-topbar-height, 0px)))',
    maxHeight: 'calc(100dvh - (60px + var(--kipify-topbar-height, 0px)))',
    display: 'flex',
    flexDirection: 'column',
    overscrollBehaviorY: 'contain',
  },
  // Contenuto drawer: altezza vincolata (flex + minHeight 0) così lo scroll avviene dentro SidebarNav
  '.MuiPaper-root > div': {
    flex: 1,
    minHeight: 0,
    display: 'flex',
    flexDirection: 'column',
  },
}));

export const HistoryButton = styled(IconButton)(() => ({
  visibility: 'hidden',
}));

export const MenuButton = styled(IconButton, {
  shouldForwardProp: (prop) => prop !== 'active',
})<MenuButtonProps>(({ active }) => ({
  '&.MuiIconButton-colorSecondary .MuiSvgIcon-root': {
    color: active ? 'rgba(30, 217, 147, 1)' : 'rgba(255, 255, 255, 1)',
  },
}));

export const Header = styled(Box)(() => ({
  position: 'fixed',
  top: 'calc(var(--kipify-topbar-height, 0px) - 1px)',
  zIndex: 1300,
  padding: '9px 10px',
  height: '60px',
  width: '100%',
  boxSizing: 'border-box',
  display: 'flex',
  justifyContent: 'space-between',
  alignContent: 'center',
  background:
    'linear-gradient(to right, rgba(0, 45, 28, 1), rgba(3, 12, 22, 1))',
  margin: 0,
  border: 'none',
  boxShadow: 'none',
  paddingTop: 'calc(9px + 1px)',
  paddingBottom: '9px',

  p: {
    color: 'rgba(30, 237, 159, 1)',
  },
}));
